
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v/[chartId]",
      function () {
        return require("private-next-pages/v/[chartId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v/[chartId]"])
      });
    }
  